module.exports = __webpack_public_path__ + "img/brasao-de-goias.6cb0af21.svg";